module.exports = "/_next/static/images/a4b6da5c3b7bf1098460944a18f8ea9e-Nubank_HickDuarte_54700_lg.jpg";